import { Stack } from '@mui/material'
import type { InternalLabelArea } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { AreaForm } from '../AreaForm/AreaForm'
import {
  AreaFormProvider,
  useAreaFormContext,
} from '../AreaForm/AreaFormContext'
import { BBoxSelector } from './BBoxSelector'
import { useLabelFormContext } from './LabelFormContext'
import { LabelSection } from './LabelSection'

type Props = {
  editingArea?: InternalLabelArea
}

// 検査箇所の編集・新規作成モードUI
export const AreaEditView: FC<Props> = ({ editingArea }) => {
  const { handleAreaSaved } = useLabelFormContext()

  return (
    <AreaFormProvider editingArea={editingArea} onAreaSaved={handleAreaSaved}>
      <AreaEditViewContent editingArea={editingArea} />
    </AreaFormProvider>
  )
}

const AreaEditViewContent: FC<Props> = ({ editingArea }) => {
  const {
    formValues: { imageUrl, calibrationAreas, areas },
    cancelEditing,
  } = useLabelFormContext()

  const { formValues, setValue } = useAreaFormContext()

  // 編集中の検査箇所は selectedBBox としてアクティブ表示されるため、非活性表示の対象から除外する
  const inactiveAreas = editingArea
    ? areas.filter(a => a.id !== editingArea.id)
    : areas

  // 位置補正基準と非活性な検査箇所を、操作不可のグレースタイルで表示する
  const otherBoxes = [
    ...calibrationAreas.map((c, i) => ({ ...c, name: `${i + 1}` })),
    ...inactiveAreas,
  ]

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      justifyContent="space-between"
    >
      <LabelSection>
        <BBoxSelector
          labelImageUrl={imageUrl}
          otherBBoxes={otherBoxes}
          selectedBBox={{
            name: formValues.name,
            x: formValues.x,
            y: formValues.y,
            width: formValues.width,
            height: formValues.height,
          }}
          onBBoxChange={{
            setX: (x: number) => setValue('x', x),
            setY: (y: number) => setValue('y', y),
            setWidth: (w: number) => setValue('width', w),
            setHeight: (h: number) => setValue('height', h),
          }}
          onCancel={cancelEditing}
        />
      </LabelSection>
      <Stack
        bgcolor="background.paper"
        height={{ xs: 'auto', md: 'calc(100vh - 64px)' }}
        width={{ md: '480px' }}
        flexShrink={0}
        mb={{ xs: 2, md: 0 }}
        overflow="auto"
      >
        <AreaForm />
      </Stack>
    </Stack>
  )
}
